import ko from "knockout";
import componentCache from "flow/utils/componentCache";
import ajaxErrorHelper from "flow/ajax/ajaxErrorHelper";
import { Dictionary } from "flow/api/types";
import Component from "flow/Component";
import bind from "bind-decorator";

export class UserContextTabs {
    tabs = ko.observableArray<Component>([]);
    isExpanded = ko.observable<boolean>(false);
    tabHandle = ko.observable();
    currentTabComponent: Component;
    previousTabComponent: Component;

    constructor() {
        this.tabHandle.subscribe(() => {
            setTimeout(() => {
                this.tabHandle().create({
                    activate: this.onActivate,
                    beforeActivate: this.onBeforeActivate
                });

                if (this.tabs().length > 0) {
                    this.loadComponentById(this.tabs()[0].manifest.id, {});
                }
            }, 1);
        });
    }

    init(manifests: any[]) {
        const tabArray = [];

        for (let i = 0; i < manifests.length; ++i) {
            tabArray.push(componentCache.getComponentById(manifests[i].id));
        }

        this.tabs(tabArray);
    }

    loadComponentById(id: string, viewContext: Dictionary) {
        const component = componentCache.getComponentById(id);
        component
            .load()
            .done(() => {
                if (this.tabs().indexOf(component) === -1) {
                    this.tabs.push(component);
                }
                component.activate(viewContext, this.closeCallback);
                component.onShow();
                this.currentTabComponent = component;
            })
            .fail(possibleJqXhr => {
                if (ajaxErrorHelper.isjqXhrObject(possibleJqXhr)) {
                    if (ajaxErrorHelper.isConnectionProblem(possibleJqXhr)) {
                        component.myFlow.handleAjaxError(possibleJqXhr);
                    }
                }
                this.currentTabComponent = undefined;
            });
    }

    @bind
    onActivate() {
        const index = this.tabHandle().getActiveTab();
        this.loadComponentById(this.tabs()[index].manifest.id, {});
    }

    @bind
    onBeforeActivate() {
        if (this.currentTabComponent != undefined) {
            this.previousTabComponent = this.currentTabComponent;
            this.previousTabComponent.onHide();
        }
    }

    @bind
    closeCallback() {
        this.isExpanded(false);
    }

    @bind
    toggle() {
        this.isExpanded(!this.isExpanded());
    }
}

const userContextTabs = new UserContextTabs();
export default userContextTabs;
